export default "__VITE_ASSET__7w1u4vV8__"